import type {FC} from 'react';

import type {Props} from './types';

import * as S from './styles';

export const CountryFlag: FC<Props> = ({countryCode, size, ...rest}) => {
  return (
    <S.Flag
      {...rest}
      disableCache
      placeholder={
        <S.FlagPlaceholder size={size}>
          <S.FlagPlaceholderText size={size}>
            {countryCode.toUpperCase()}
          </S.FlagPlaceholderText>
        </S.FlagPlaceholder>
      }
      size={size}
      src={`https://flagpedia.net/data/flags/normal/${countryCode.toLowerCase()}.png`}
    />
  );
};
